export const getLast = async ({ entityName, entityId, $http }) => {
    const res = await $http.get(
      `/Changelog/${entityName}/${entityId}/Last`,
    );

    return res.data;
  };